export const playbackSpeeds = [
  { speed: 0.75, label: '0.75 x' },
  { speed: 1, label: 'Standard' },
  { speed: 1.25, label: '1.25 x' },
  { speed: 1.5, label: '1.50 x' },
  { speed: 1.75, label: '1.75 x' },
  { speed: 2, label: '2 x' }
];

export const smallplaybackSpeeds = [
  { speed: 0.75, label: '0.75 x' },
  { speed: 1, label: 'Standard' }
];

export function formatSpeed(speed: number) {
  const item = playbackSpeeds.find(ps => ps.speed === speed);
  if (!item) throw new Error(`Invalid playback speed ${speed}`);
  return item.label;
}
